export const maxInputLength = 100;
//export const autocompleteMinimalCharacters = 2 - unused after removing autocomplete
export const resultsPerPage = 20;
export const chapterPageSize = 50;
export const chapterString = "chapter";
//export const resultString = 'result' - unused?
export const searchString = "search";
export const collectionsString = "collections";
//export const codeValueString = 'codeValue' - unused?
export const historyString = "history";
